import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom';
import Head from './head';
import Nav from './nav';
import './css/recommendation-results.css'
import Scripts from './scripts';
import Footer from './footer';
import {API_BASE} from "../apiConfig";

function Results() {

    const [recommendations, setRecommendations] = useState([])
    const dormNames = ["barbour", "caswell", "diman", "chapin", "goddard", "greg", "harkness", "hegeman",
        "hope", "littlefield", "marcy", "minden", "morris", "olney", "perkins", "sears", "slater"]
    const [rec_zero, setRecZero] = useState("")
    const [rec_one, setRecOne] = useState("")
    const [rec_two, setRecTwo] = useState("")
    // "loading" | "ready" | "empty" | "error"
    const [pageState, setPageState] = useState("loading")

    const dormPhoto = (name) => {
        const lower = (name || "").toLowerCase();
        if (dormNames.includes(lower)) return require('./img/outside/' + lower + '.jpg');
        if (lower === "grad center") return require('./img/outside/gradcenter.jpg');
        if (lower === "new pembroke") return require('./img/outside/pembroke.jpg');
        if (lower === "young orchard") return require('./img/outside/youngo.jpg');
        return require('./img/outside/wellness.jpg');
    }

    const displayRecommendations = async () => {
        try {
            const response = await fetch(`${API_BASE}/displayRecommendations`, {
                method: 'POST',
                headers: {"Access-Control-Allow-Origin": "*"}
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            const data = await response.json();

            if (!data || data.length === 0) {
                setPageState("empty");
                return;
            }

            setRecommendations(data);
            setRecZero(dormPhoto(data[0]));
            setRecOne(dormPhoto(data[1]));
            setRecTwo(dormPhoto(data[2]));
            setPageState("ready");
        } catch (error) {
            console.log("Error: Failed to fetch recommendations", error);
            setPageState("error");
        }
    }

    useEffect(() => {
        displayRecommendations()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="recs">
            <Head/>
            <Nav/>
            <div className="results-header">
                <h1>Your Recommended Dorms</h1>
                <p>Based on your answers, here's a short list worth touring.</p>
            </div>

            {pageState === "loading" ? (
                <div className="page-loading">
                    <div className="spinner"></div>
                    <p>Finding your matches&hellip;</p>
                </div>
            ) : pageState === "error" ? (
                <div className="page-error">
                    <p>Couldn't load your recommendations right now.</p>
                    <button type="button" className="btn-secondary retry-btn" onClick={displayRecommendations}>Try again</button>
                </div>
            ) : pageState === "empty" ? (
                <div className="page-error">
                    <p>We couldn't find a match for those preferences &mdash; try the quiz again with a few different answers.</p>
                    <Link className="btn-secondary retry-btn" to="/recommend">Retake the quiz</Link>
                </div>
            ) : (
                <div className="results-grid">
                    <div className="result-card">
                        <div className="result-photo" style={{backgroundImage: `url(${rec_zero})`}}>
                            <span className="rank">1</span>
                        </div>
                        <div className="result-body"><h3>{recommendations[0]}</h3></div>
                    </div>
                    <div className="result-card">
                        <div className="result-photo" style={{backgroundImage: `url(${rec_one})`}}>
                            <span className="rank">2</span>
                        </div>
                        <div className="result-body"><h3>{recommendations[1]}</h3></div>
                    </div>
                    <div className="result-card">
                        <div className="result-photo" style={{backgroundImage: `url(${rec_two})`}}>
                            <span className="rank">3</span>
                        </div>
                        <div className="result-body"><h3>{recommendations[2]}</h3></div>
                    </div>
                </div>
            )}

            <Footer/>
            <Scripts/>
        </div>
    );
}

export default Results;
